import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';

/** "Try again" in the unreachable notice's action slot: a plain underlined text button, the same
 *  treatment as the provisioning screen's retry. */
export const RetryLink = styled.button`
  appearance: none;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.textStrong};
  text-decoration: underline;
  text-underline-offset: 3px;
  white-space: nowrap;
`;
